module.exports = __webpack_public_path__ + "media/images/icône avion-0d5d7d13956959af937e23911298a573.svg";